import {SegmentedControlProps} from "../SegmentedControl/SegmentedControl";
import {SegmentedControl} from "@mantine/core";
import {getTransportCategory, transportCategories} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {getTransportCategoryColorRefByType} from "../../../util/transport-category-ui-util";

export type TransportCategorySegmentedControlProps = Omit<SegmentedControlProps, 'data' | 'color'> & {
  includeAll?: boolean
}

export const TransportCategorySegmentedControl = (props: TransportCategorySegmentedControlProps) => {
  const {includeAll = false, value, ...rest} = props

  const {t} = useTranslation(["common"])

  const data = useMemo(() => {
    const _data = []

    if (includeAll) {
      _data.push({
        label: t<string>("common.entity.transportcategory.all", "All"),
        value: 'all',
      })
    }

    transportCategories.forEach((c) => {
      _data.push({
        label: t<string>(c.displayValue.id, c.displayValue.defaultMessage),
        value: c.code,
      })
    })

    return _data
  }, [t, includeAll])

  const color = useMemo(() => {
    const category = value ? getTransportCategory(value) : undefined
    return category ? getTransportCategoryColorRefByType(category) : undefined
  }, [value])

  return (
    <SegmentedControl
      {...rest}
      data={data}
      value={value}
      color={color}
    />
  )
}
